// React
import React from 'react';
import classnames from 'classnames';
import {
  Col,
  Row,
  Nav,
  Card,
  Form,
  Button,
  NavItem,
  NavLink,
  TabPane,
  CardBody,
  Container,
  CardFooter,
  CardHeader,
  TabContent,
} from 'reactstrap';

// Containers Injections & Components View's
import {
  PageWrapper,
  LoadingScreen,
  ModalReasonCancel,
  ProposalsButtonGroup,
  ModalReasonChangeStatus,
} from '../../containers/componentsInjection';
import HistoryStatus from './views/HistoryStatus';
import { GeneralInfo } from './views/GeneralInfo';
import { PaymentInfo } from './views/paymentInfo';
import { ServicesInfo } from './views/ServicesInfo';
import { HeaderInvoice } from './views/headerInvoice';
import { DependentsInfo } from './views/DependentsInfo';
import { UploadFilesInfo } from './views/UploadFilesInfo';
import ModalReactivateProposal from './views/modalReactivateProposal';

export const ProposalsFormPage = ({
  // Data
  idProposal,
  hashidProposal,
  canEdit,
  offices,
  filesData,
  plansData,
  lastUpdated,
  sellersData,
  cancellation,
  servicesData,
  kinshipsData,
  maxDependents,
  organizationsData,
  categoryPlansData,
  paymentMethodsData,
  // Helpers
  isView,
  history,
  loading,
  tabChange,
  activeTab,
  validation,
  isModalOpen,
  toggleCancel,
  customerName,
  canReactivate,
  showMembership,
  showEmployment,
  showOrganization,
  setShowMembership,
  setShowEmployment,
  toggleChangeStatus,
  setShowOrganization,
  handleSubmitCancelModal,
  isModalReactivateOpen,
  isModalChangeStatusOpen,
  handleSubmitChangeStatus,
  toggleAssistenceDependent,
  toggleReactivateProposalModal,
  handleSubmitReactivateProposal,
}) => {
  return (
    <LoadingScreen loading={loading} titleMetaTag={'Propostas'}>
      <PageWrapper title={'Propostas'}>
        <Row className="justify-content-center">
          <Col xxl={12}>
            <Card>
              <CardHeader>
                <Nav
                  className="nav-tabs-custom rounded card-header-tabs border-bottom-0"
                  role="tablist"
                >
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === '1' })}
                      onClick={() => {
                        tabChange('1');
                      }}
                      style={{ cursor: 'pointer' }}
                    >
                      <i className="fas fa-home"></i>
                      Informações Gerais
                    </NavLink>
                  </NavItem>
                  <NavItem hidden={!hashidProposal}>
                    <NavLink
                      className={classnames({ active: activeTab === '2' })}
                      onClick={() => {
                        tabChange('2');
                      }}
                      style={{ cursor: 'pointer' }}
                    >
                      <i className="fas fa-home"></i>
                      Histórico de Eventos
                    </NavLink>
                  </NavItem>
                </Nav>
              </CardHeader>

              <TabContent activeTab={activeTab}>
                <TabPane tabId={'1'}>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                    name="invoice_form"
                    className="needs-validation"
                    id="invoice_form"
                  >
                    <CardBody className="border-bottom border-bottom-dashed p-4">
                      <HeaderInvoice
                        id={hashidProposal}
                        canEdit={canEdit}
                        validation={validation}
                        cancellation={cancellation}
                        status={validation.values.statusInput}
                        statusColor={validation.values.statusColor}
                        name={validation.values.customerInput || customerName}
                        numberContract={validation.values.numberContractInput}
                      />
                    </CardBody>
                    <CardBody className="p-4">
                      <GeneralInfo
                        isView={isView}
                        offices={offices}
                        showOrganization={showOrganization}
                        showEmployment={showEmployment}
                        showMembership={showMembership}
                        setShowMembership={setShowMembership}
                        setShowEmployment={setShowEmployment}
                        setShowOrganization={setShowOrganization}
                        plansData={plansData}
                        validation={validation}
                        categoryPlansData={categoryPlansData}
                        organizationsData={organizationsData}
                      />
                    </CardBody>
                    <CardBody className="p-4 border-top border-top-dashed">
                      <PaymentInfo
                        isView={isView}
                        validation={validation}
                        sellersData={sellersData}
                        paymentMethodsData={paymentMethodsData}
                      />
                    </CardBody>
                    <CardBody className="p-4 border-top border-top-dashed">
                      <DependentsInfo
                        isView={isView}
                        validation={validation}
                        kinshipsData={kinshipsData}
                        maxDependents={maxDependents}
                        toggleAssistenceDependent={toggleAssistenceDependent}
                      />
                    </CardBody>
                    <CardBody className="p-4 border-top border-top-dashed">
                      <ServicesInfo
                        isView={isView}
                        validation={validation}
                        servicesData={servicesData}
                      />
                    </CardBody>

                    {hashidProposal && (
                      <CardBody className="p-4 border-top border-top-dashed">
                        <UploadFilesInfo
                          id={idProposal}
                          isView={isView}
                          filesData={filesData}
                          validation={validation}
                          numberContract={validation.values.numberContractInput}
                        />
                      </CardBody>
                    )}
                    <CardFooter className="p-3">
                      <Row>
                        {hashidProposal && !cancellation && (
                          <Col md={6} className="d-flex align-items-center">
                            <span className="card-text ">
                              <small className="text-muted">
                                {lastUpdated}
                              </small>
                            </span>
                          </Col>
                        )}

                        {hashidProposal && canReactivate && (
                          <Col md={!cancellation ? 6 : 12}>
                            <div className="hstack justify-content-end">
                              <Button
                                type="button"
                                color="success"
                                onClick={() => toggleReactivateProposalModal()}
                              >
                                Reativar Proposta
                              </Button>
                            </div>
                          </Col>
                        )}

                        {isView && (
                          <Col className="hstack justify-content-end">
                            {!cancellation && (
                              <ProposalsButtonGroup
                                buttons={[
                                  {
                                    id: 1,
                                    title: 'Cancelar Proposta',
                                    action: () => toggleCancel(),
                                  },
                                  {
                                    id: 2,
                                    title: 'Alterar Situação',
                                    action: () => toggleChangeStatus(),
                                  },
                                ]}
                              />
                            )}

                            {canEdit && (
                              <>
                                <button
                                  type="button"
                                  className="btn btn-link"
                                  onClick={() => history.goBack()}
                                >
                                  Voltar
                                </button>
                                <Button
                                  type="button"
                                  className="btn"
                                  onClick={() => {
                                    history.push(
                                      `/propostas/editar/${hashidProposal}`
                                    );
                                  }}
                                >
                                  Editar
                                </Button>
                              </>
                            )}
                          </Col>
                        )}

                        {!isView && (
                          <Col
                            className="hstack justify-content-end gap-2"
                            md={hashidProposal ? 6 : 12}
                          >
                            {hashidProposal && !cancellation && (
                              <ProposalsButtonGroup
                                buttons={[
                                  {
                                    id: 1,
                                    title: 'Cancelar Proposta',
                                    action: () => toggleCancel(),
                                  },
                                  {
                                    id: 2,
                                    title: 'Alterar Situação',
                                    action: () => toggleChangeStatus(),
                                  },
                                ]}
                              />
                            )}

                            <button
                              type="button"
                              className="btn btn-link"
                              onClick={() => history.goBack()}
                            >
                              Voltar
                            </button>
                            <Button type="submit" className="btn btn-primary">
                              Salvar
                            </Button>
                          </Col>
                        )}
                      </Row>
                    </CardFooter>

                    <ModalReasonChangeStatus
                      isOpen={isModalChangeStatusOpen}
                      toogle={toggleChangeStatus}
                      handleSubmit={handleSubmitChangeStatus}
                      status={validation.values.proposal_status_id}
                    />

                    <ModalReasonCancel
                      isOpen={isModalOpen}
                      toogle={toggleCancel}
                      title="Cancelar Proposta"
                      label="Informe o motivo do cancelamento"
                      handleSubmit={handleSubmitCancelModal}
                    />

                    <ModalReactivateProposal
                      isOpen={isModalReactivateOpen}
                      toggle={toggleReactivateProposalModal}
                      handleSubmitReactivateProposal={
                        handleSubmitReactivateProposal
                      }
                    />
                  </Form>
                </TabPane>
                <TabPane tabId="2">
                  <HistoryStatus id={idProposal} />
                </TabPane>
              </TabContent>
            </Card>
          </Col>
        </Row>
      </PageWrapper>
    </LoadingScreen>
  );
};
